import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
    selector: 'app-drive-file-card',
    standalone: true,
    imports: [
        CommonModule,
        NzButtonModule,
        NzIconModule,
        NzTooltipModule
    ],
    templateUrl: './drive-file-card.component.html',
    styleUrls: ['./drive-file-card.component.scss']
})
export class DriveFileCardComponent {
    @Input() canEdit!: boolean;
    @Input() fileId?: string | null;
    @Input() folderId?: string | null;
    @Input() fileName?: string | null;
    @Input() fileLink?: string | null;

    @Input() showMetadata: boolean = false; 
    @Input() showRemove: boolean = false;   
    
    @Input() iconType: string = 'file-text';
    @Input() iconTheme: 'outline' | 'twotone' | 'fill' = 'twotone';
    @Input() iconColor: string = '#1890ff';

    @Output() browse = new EventEmitter<void>();
    @Output() remove = new EventEmitter<void>();

    // New state variable for the accordion
    isMetadataExpanded = false;

    constructor(private toastr: ToastrService) {}

    // New toggle method
    toggleMetadata() {
        this.isMetadataExpanded = !this.isMetadataExpanded;
    }

    copyToClipboard(text: string | null | undefined, fieldName: string) {
        if (!text) return;
        navigator.clipboard.writeText(text).then(
            () => this.toastr.success(`${fieldName} copied to clipboard`),
            () => this.toastr.error(`Failed to copy ${fieldName}`)
        );
    }
}